/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventanswerstitle2Inputs */

const en_eventanswerstitle2 = /** @type {(inputs: Eventanswerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers`)
};

const de_eventanswerstitle2 = /** @type {(inputs: Eventanswerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

/**
* | output |
* | --- |
* | "Answers" |
*
* @param {Eventanswerstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventanswerstitle2 = /** @type {((inputs?: Eventanswerstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventanswerstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventanswerstitle2(inputs)
	return de_eventanswerstitle2(inputs)
});
export { eventanswerstitle2 as "eventAnswersTitle" }